export enum DemandReportingActionType {
  GET_PERSONAL_LOAN_SUMMARY_BY_DEMAND_SUBACCOUNT_UUID_FAILURE = '@@analytics/GET_PERSONAL_LOAN_SUMMARY_BY_DEMAND_SUBACCOUNT_UUID_FAILURE',
  GET_PERSONAL_LOAN_SUMMARY_BY_DEMAND_SUBACCOUNT_UUID_REQUEST = '@@analytics/GET_PERSONAL_LOAN_SUMMARY_BY_DEMAND_SUBACCOUNT_UUID_REQUEST',
  GET_PERSONAL_LOAN_SUMMARY_BY_DEMAND_SUBACCOUNT_UUID_SUCCESS = '@@analytics/GET_PERSONAL_LOAN_SUMMARY_BY_DEMAND_SUBACCOUNT_UUID_SUCCESS',
}
